import React, { useContext, useEffect, useState } from "react"
import { watchBattery } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBatteryEmpty, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryFull, faSpinner } from '@fortawesome/free-solid-svg-icons'
import Context from "../utils/Context"

export default function BatteryStatus({ robot }) {
    const context = useContext(Context)

    const [battery, setBattery] = useState()

    useEffect(() => {
        if (!robot) setBattery(context.battery)
        else setBattery(context.currentBatteries[robot]?.percentage)
    }, [context.currentBatteries[robot]?.percentage, context?.battery])

    let iconBattery
    switch (true) {
        case !battery: iconBattery = faSpinner; break
        case battery <= 8: iconBattery = faBatteryEmpty; break
        case battery <= 25: iconBattery = faBatteryQuarter; break
        case battery <= 50: iconBattery = faBatteryHalf; break
        case battery <= 75: iconBattery = faBatteryThreeQuarters; break
        case battery > 75: iconBattery = faBatteryFull; break
        default: iconBattery = faSpinner; break
    }

    return (
        <div className="column">
            <p className="pt-2">
                <span className={iconBattery === faBatteryEmpty ? "icon has-text-danger " : ""} >
                    {iconBattery && <FontAwesomeIcon icon={iconBattery} className={iconBattery === faSpinner ? "fas fa-pulse" : ""} />}
                </span>

                <span className="content is-small ml-2">
                    {battery ? battery : '??'}%
                </span>
            </p>
        </div>

    )
}